import { QuestionData, SectionData } from '@playbooks/action-cards-utils/src'

import { WebPlayQuestionFileUploadStorageService } from './WebPlayQuestionFileUploadStorageService'

export class FileUploadServiceProvider {
  playbookId: string

  constructor(playbookId: string) {
    this.playbookId = playbookId
  }

  getService(question: QuestionData) {
    return new FileUploadService(this.playbookId, question)
  }
}

class FileUploadService {
  playbookId: string
  question: QuestionData
  storageService: WebPlayQuestionFileUploadStorageService

  get isDisabled() {
    return !this.playbookId
  }

  constructor(playbookId: string, question: QuestionData) {
    this.playbookId = playbookId
    this.question = question
    this.storageService = new WebPlayQuestionFileUploadStorageService(this.playbookId)
  }

  async deleteFile(fileItem: { id: number; name: string }) {
    await this.storageService.deleteFile(fileItem)
  }

  async uploadFiles(uploadingFiles: File[], currentHeader: SectionData) {
    const newFileItems = []
    for (let i = 0; i < uploadingFiles.length; i++) {
      const file = uploadingFiles[i]
      try {
        if (file.size > 30 * 1024 * 1024) {
          throw new Error('File size exceeds the limit of 30MB')
        }
        await this.storageService.saveFile(this.question, currentHeader, file).then(id => {
          newFileItems.push({ id: id, name: file.name })
        })
      } catch (error: unknown) {
        newFileItems.push({ id: 0, name: file.name, error: error instanceof Error ? error.message : String(error) })
      }
    }
    return newFileItems
  }
}
